import * as firebase from 'firebase'

const config = {
  apiKey: "AIzaSyCh2KvJ0CEhi6VGyR3uENxlYc966DHcXC4",
  authDomain: "cs-web-home.firebaseapp.com",
  databaseURL: "https://cs-web-home.firebaseio.com",
  projectId: "cs-web-home",
  storageBucket: "cs-web-home.appspot.com",
  messagingSenderId: "896800570000",
  appId: "1:896800570000:web:f776dcc5044f4dca08f615",
  measurementId: "G-TV7WF3J0SZ"
}

firebase.initializeApp(config)

const googleProvider = new firebase.auth.GoogleAuthProvider()

export const signUpWithEmailAndPassword = async (email, password) => {
  const res = firebase.auth().createUserWithEmailAndPassword(email, password)
    .then(result => {
      console.log('user sucessfully created with password', result)
      return { status: 'success', action: 'sign up', method: 'password', user: result.user }
    })
    .catch(error => {
    // Handle Errors here.
    console.log('there was an error: ', error.code, error.message)
    return { status: 'error', code: error.code, message: error.message }
    // ...
  })
  return res
}

export const signInWithEmailAndPassword = async (email, password) => {
  const res = firebase.auth().signInWithEmailAndPassword(email, password)
  .then(result => {
    return { status: 'success', action: 'sign in', method: 'password', user: result.user }
  })
  .catch(error => {
  // Handle Errors here.
  var errorCode = error.code;
  var errorMessage = error.message;
  return { status: 'error', code: error.code, message: error.message }
  // ...
  })
  return res
}

const firebaseAuth = (provider) => {
  const res = firebase.auth().signInWithPopup(provider)
    .then(result => {
      var token = result.credential.accessToken
      var user = result.user
      var isNewUser = result.additionalUserInfo.isNewUser
      if(isNewUser) return { status: 'success', action: 'sign up', method: provider, user: user }
      else return { status: 'success', action: 'sign in', method: provider, user: user } 
    })
    .catch(error => {
      console.log(`there was an error logging in user with ${provider} in new firebase file`)
      var errorCode = error.code;
      var errorMessage = error.message
      return { status: 'error', code: error.code, message: error.message }
    })
  return res
}

export const db = firebase.firestore()
export const authRef = firebase.auth()
export const loginGoogle = () => firebaseAuth(googleProvider)
export const functions = firebase.functions()
export const firestore = firebase.firestore
